/**
 * 反馈页用户详情入口：按工单所属账号读取真实用户行，复用用户管理的完整详情抽屉。
 */
import { useEffect } from 'react';
import { useUsersPage } from '~/data/queries';
import { UserDetail } from '~/pages/users/UsersPage';
import { Drawer } from '~/ui/Dialog';

/** GDPR 匿名占位账号聚合已注销用户的保留事实，不能作为某个工单的可查看账号。 */
export function hasFeedbackAccount(userId: string | null): userId is string {
  return userId !== null && userId !== '019e5401-475e-7320-b3f9-7849a23d949d';
}

export function FeedbackUserDetailDrawer({
  userId,
  onClose,
}: { userId: string; onClose: () => void }) {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);
  const { data: users, isLoading } = useUsersPage({
    page: 1,
    pageSize: 100,
    filters: { q: userId },
  });
  const user = users.find((candidate) => candidate.id === userId);
  if (user) return <UserDetail key={user.id} user={user} onClose={onClose} />;
  return (
    <Drawer title="用户详情" onClose={onClose}>
      <div style={{ padding: 18, color: 'var(--fg-muted)' }}>
        {isLoading ? '加载用户详情…' : '用户详情暂不可用，请关闭后重试'}
      </div>
    </Drawer>
  );
}
